import React from "react";
import "./styles.css";

const Footer: React.FC = () => {
  return (
    <footer id="footer">
      <div id="copyright" className="container">
        &copy; New Peking Chinese Restaurant. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
